import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";


const LogoutModal = ({ onCancel, onConfirm }) => {
  return (
    <SweetAlert
      title=""
      custom
      confirmBtnBsStyle="danger mb-3 fs-5 rounded"
      cancelBtnBsStyle="secondary mb-3 fs-5 rounded text-white"
      confirmBtnText="Logout"
      cancelBtnText="No, Cancel"
      onConfirm={onConfirm}
      onCancel={onCancel}
      showCancel
      focusCancelBtn
    >
      <div style={{ textAlign: '' }}>
        <p className="sweet-text mb-3">Are you sure want to logout?</p>
      </div>
    </SweetAlert>
  );
};

export default LogoutModal;
